import * as Sentry from '@sentry/react';
import { t } from 'i18next';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
  RegisterPaymentRequest,
  RegisterPaymentResponse,
} from '@cashier/cashier-api-model';

import { PaymentActionMapper } from '../common/mapper';
import {
  registerPaymentStart,
  registrationPaymentFailure,
  registrationPaymentSuccess,
} from './paymentRegistration.slice';

export const paymentRegistrationEpic = (action$, state$, { Api }) =>
  action$.pipe(
    ofType(registerPaymentStart.type),
    switchMap((action: { payload: RegisterPaymentRequest }) =>
      Api.registerPayment(action.payload).pipe(
        map((data: RegisterPaymentResponse) => {
          if (data.resultAction === null) {
            Sentry.captureException(
              new Error(
                '###Successful status returned, but resultAction is null. Status###:',
              ),
              {
                extra: {
                  status: data.status,
                },
              },
            );

            return registrationPaymentFailure({
              message: t('failureRegistrationChannel.message'),
              attributeErrorBag: null,
              errorDetails: null,
              transactionId: null,
            });
          }

          return registrationPaymentSuccess(
            PaymentActionMapper.toResultAction(data.resultAction),
          );
        }),
        catchError((err) =>
          of(
            registrationPaymentFailure(
              PaymentActionMapper.toPaymentActionError(err),
            ),
          ),
        ),
      ),
    ),
  );

export const registerPayment = (data: RegisterPaymentRequest) => ({
  type: registerPaymentStart.type,
  payload: data,
});
